<template>
  <div>
    <Mt5DashboardMock />
  </div>
</template>

<script>
import Mt5DashboardMock from "@/components/WebTrade/Mt5DashboardMock.vue";

export default {
  components: {
    Mt5DashboardMock,
  },
};
</script>